// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import TouchCardLayerBase from "../common/TouchCardLayerBase";
import { TouchCardChallengeKind } from "./data/TouchCardChallengeKind";
import TouchCardChallengeItem from "./TouchCardChallengeItem";

const {ccclass, property} = cc._decorator;

const c_winCount = 3;
const c_hintCard = [4, 2];
/** 连胜给地图道具 */
const c_winMapProp = 5;
@ccclass
export default class TouchCardChallengeLayer extends TouchCardLayerBase {

	@property({ type: cc.Node, displayName:'' })
	sprBlack: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeLose: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeWin: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	ico_tishi: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeDesc: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnPurchase: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCombinationLayout: cc.Node = null;

    @property(cc.Prefab)
    cardPrefab: cc.Prefab = null;

    private winCardData: number = null;
    private hintCount = 0;

    /** 连胜次数 */
    private winConCount = 0;
    private winConCount2 = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        super.start();

        this.showCardArr();
        this.resetData();

        this.winConCount2 = NormalGameManager._instance.getGameData().touchCardConWin;
    }

    resetData() {
        super.resetData();

        this.sprBlack.active = false;
        this.nodeLose.active = false;
    	this.nodeWin.active = false;
        let children = this.nodeCombinationLayout.children;
        children.forEach((v,i)=> {
            let script = v.getComponent(TouchCardChallengeItem);
            script.resetData();
        });

        this.hintCount = 0;
        this.ico_tishi.active = true;
        this.nodeDesc.active = true;
        this.btnPurchase.active = false;
        this.refreshTouchCardData();
    }

    refreshTouchCardData() {
        let touchList = TouchCardChallengeKind.CardTouchList;
        let len = touchList.length;
        let idx = data_control.randomNumInt(0, len-1);
        let cardData = this.winCardData = touchList[idx];
        this.cardTouch.setData(cardData, this);
    }

    showCardArr() {
        this.nodeCombinationLayout.removeAllChildren();
        for (let o of TouchCardChallengeKind.CardTypeArea) {
            for (let i = o[0]; i <= o[1]; i++) {
                let cardNode = cc.instantiate(this.cardPrefab);
                this.nodeCombinationLayout.addChild(cardNode);
                let script = cardNode.getComponent(TouchCardChallengeItem);
                script.setData(i, this);
            }
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let bSave = false;
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.touchCardConWin != this.winConCount2) {
            gameData.touchCardConWin = this.winConCount2;
            bSave = true;
        }
        
        // gameData.touchCardConWin
        if (this.winConCount >= c_winCount && !gameData.bTouchCardConWin) {
            gameData.bTouchCardConWin = true;
            bSave = true;
            utilsView.openEventLayer(
                null
                , {
                    id: '12'
                    , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                    , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                    , saveData: ()=> {
                        
                    }
                    , exitLayer: ()=> {
                        
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        }

        if (bSave) {
            NormalGameManager._instance.writeGameData();
        }
        this.destroyNode();
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsModel.loadAndShowVideoAdTrans(()=>{
            // this.resetStartLottery();
            this.showHint();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"观看视频获得摸牌提示");
    }

    showHint() {
        if (this.hintCount > 2) {
            return;
        }
        this.shieldCard(c_hintCard[this.hintCount]);
        this.hintCount++;

        if (this.hintCount >= 2) {
            this.ico_tishi.active = false;
        }
    }

    shieldCard(count: number) {
        if (!count) {
            return;
        }
        let children = this.nodeCombinationLayout.children;
        let validArr: number[] = [];
        let self = this;
        children.forEach((v,i)=> {
            let script = v.getComponent(TouchCardChallengeItem);
            let cardData = script.getCardData();
            if (script.isEnable() && cardData != self.winCardData) {
                validArr.push(i);
            }
        });

        count = Math.min(validArr.length, count);
        let validList = data_control.randomIntNum(0, validArr.length-1, count);

        // cc.log('最后的数据', count, validList, validArr);
        for (let o of validList) {
            let idx = validArr[o];
            let nodeItem = children[idx];
            let script = nodeItem.getComponent(TouchCardChallengeItem);
            script.setValid(false);
        }
    }

    async showRet(card: number) {

        this.cardTouch.setTouchState(false);
        this.ico_tishi.active = false;
        let children = this.nodeCombinationLayout.children;
        children.forEach((v,i)=> {
            let script = v.getComponent(TouchCardChallengeItem);
            script.setClickState(false);
        });

        await this.cardTouch.endShow();
        if (!this.node || !cc.isValid(this.node)) {
            return;
        }

        this.sprBlack.active = true;
        this.nodeLose.active = false;
        this.nodeWin.active = false;

        if (card == this.winCardData) {
            this.winConCount++;
            this.winConCount2++;
            // 胜利
            let gold = TouchCardChallengeKind.GeneralValue.AWARD_NUM;
            O1HD.getServices().userSrv.setCoins(gold, true, this.cardTouch.node);
            this.nodeWin.active = true;

            if (this.winConCount2 >= c_winMapProp) {
                this.winConCount2 = 0;

                let addGoodsList = {};
                addGoodsList[50025] = 1;
                await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
                NormalGameManager._instance.onPushGoods(50025,1);
            }

        } else {
            if (this.winConCount < c_winCount) {
                this.winConCount = 0;
            }
            this.winConCount2 = 0;
            this.nodeLose.active = true;
        }
        this.nodeDesc.active = false;
        this.btnPurchase.active = true;
        
    }
    // update (dt) {}
}
